<template>
	<div class="home">
		<section class="slider">
			<agile :fade="true" :navButtons="false" :autoplay="true" :autoplaySpeed="3500" :speed="1000">
				<div class="slide">
					<img :src="`${publicPath}images/home_slide1_en.jpg`" class="desktop" v-if="$t('lang') === 'en'">
					<img :src="`${publicPath}images/home_slide_1_zh.jpg`" class="desktop" v-if="$t('lang') === 'zh'">
					<img :src="`${publicPath}images/m/home_slide1.jpg`" class="mobile">
				</div>
				<div class="slide">
					<img :src="`${publicPath}images/home_slide2.jpg`" class="desktop">
					<img :src="`${publicPath}images/m/home_slide2.jpg`" class="mobile">
				</div>
				<div class="slide">
					<img :src="`${publicPath}images/home_slide3.jpg`" class="desktop">
					<img :src="`${publicPath}images/m/home_slide3.jpg`" class="mobile">
				</div>
			</agile>
			<!-- <carousel :perPage="1" :autoplay="true" :loop="true" :autoplayHoverPause="false" :autoplayTimeout="4000" :easing="0">
				<slide>
					<img :src="`${publicPath}images/home_slide1.jpg`" class="desktop">
					<img :src="`${publicPath}images/m/home_slide1.jpg`" class="mobile">
				</slide>
				<slide>
					<img :src="`${publicPath}images/home_slide2.jpg`" class="desktop">
					<img :src="`${publicPath}images/m/home_slide2.jpg`" class="mobile">
				</slide>
				<slide>
					<img :src="`${publicPath}images/home_slide3.jpg`" class="desktop">
					<img :src="`${publicPath}images/m/home_slide3.jpg`" class="mobile">
				</slide>
			</carousel> -->
		</section>

		<section class="home-intro">
			<h1 class="mobile">{{ $t("home1") }}</h1>
			<p v-html="$t('home2')"></p>
		</section>

		<section class="values">
			<div class="top-img"><img :src="`${publicPath}images/home_1.jpg`"></div>
			<div class="container">
				<h2>{{ $t("home3") }}</h2>
				<div class="flex">
					<div class="left">
						<img :src="`${publicPath}images/Innovation.png`" class="innovation">
						<h3>{{ $t("home4") }}</h3>
						<p>{{ $t("home5") }}</p>
						<p>{{ $t("home6") }}</p>
					</div>

					<div class="right">
						<img :src="`${publicPath}images/Excellence.png`" class="excellence">
						<h3>{{ $t("home7") }}</h3>
						<p>{{ $t("home8") }}</p>

						<img :src="`${publicPath}images/Empathy.png`" class="empathy">
						<h3>{{ $t("home9") }}</h3>
						<p>{{ $t("home10") }}</p>

						<img :src="`${publicPath}images/Integrity.png`" class="integrity">
						<h3>{{ $t("home11") }}</h3>
						<p>{{ $t("home12") }}</p>
					</div>
				</div>

				<div class="home-line"><img :src="`${publicPath}images/home_line.png`"></div>
			</div>
		</section>

		<section class="contact">
			<div class="container desktop">
				<img :src="`${publicPath}images/home_2.jpg`">
				<img :src="`${publicPath}images/home_3.jpg`" style="margin-bottom: -2%;">
				<img :src="`${publicPath}images/home_4.jpg`" style="margin-bottom: -4%;">
				<router-link to="contact-us" v-if="$t('lang') === 'en'"><img :src="`${publicPath}images/home_5.jpg`"></router-link>
				<router-link to="contact-us" v-if="$t('lang') === 'zh'"><img :src="`${publicPath}images/home_5_chi.jpg`"></router-link>
				<img :src="`${publicPath}images/home_6.jpg`" style="margin-bottom: -3%;">
				<img :src="`${publicPath}images/home_7.jpg`" style="margin-bottom: -1%;">
				<img :src="`${publicPath}images/home_8.jpg`" style="margin-bottom: -4%;">
			</div>
			<div class="container mobile">
				<img :src="`${publicPath}images/m/home_bar_small.jpg`">
			</div>
			<div class="contact-button mobile">
				<router-link :to="{ name: 'contact-us' }">{{ $t("contactUs") }}</router-link>
			</div>
		</section>

		<footer>
			<div class="container">
				<div class="copyright">
					Copyright &copy; 2019 GraceMed. All Rights Reserved.
				</div>
			</div>
		</footer>
	</div>
</template>

<script>
import { Carousel, Slide } from 'vue-carousel';
import { VueAgile } from 'vue-agile'
import i18n from '@/components/i18n'

export default {
	name: 'home',
	components: {
		Carousel,
	    Slide,
	    agile: VueAgile
	},
	data () {
		return {
			publicPath: process.env.BASE_URL,
			mobileNav: false
		}
	},
	methods: {
		toggleMobileNav() {
			this.mobileNav = !this.mobileNav
		}
	}
}
</script>

<style>
.home .slider {
	padding-top: 70px;
}

.slider img {
	width: 100%;
}

.agile__actions {
	width: 100%;
	text-align: center;
	margin-top: -50px;
}

.agile__dots {
	margin: auto;
	position: relative;
}

.agile__dot button {
	width: 10px;
	height: 10px;
	border-radius: 50%;
	background: #FFF;
	border: 1px solid #FFF;
	padding: 0;
	margin: 5px 15px;
}

.agile__dot.agile__dot--current button {
	background: none;
}

.VueCarousel-dot--active {
	border: 1px solid #fff !important;
	background: none !important;
	padding: 0 !important;
	margin: 20px 10px !important;
}

.VueCarousel-pagination {
	margin-top: -7%;
	z-index: 100;
}

.home-intro {
	margin: 150px 0 100px 0;
}

.home-intro h1 {
	font-size: 2.5em;
	color: #85745f;
	text-align: center;
	font-family: "Times New Roman", Times, serif;
}

.zh .home-intro h1 {
	font-family: 'Raleway', 'Avenir', Helvetica, Arial, sans-serif;
}

.home-intro p {
	font-size: 1.2em;
	line-height: 1.2em;
	color: #66696d;
	width: 30%;
	margin: auto;
	margin-top: -20px;
}

.home-intro p span {
	color: #f39d00;
}

.values {
	background: #f1eae6;
	margin-top: 400px ;
	text-align: left;
	padding-bottom: 20px;
	position: relative;
	margin-bottom: 100px;
}

.values .top-img {
	width: 50%;
	margin: auto;
}

.values .top-img img {
	width: 100%;
	margin-top: -200px;
}

.values h2 {
	font-weight: 100;
	margin: 0;
	padding: 40px 0 20px 0;
	text-transform: uppercase;
	font-family: "Times New Roman", Times, serif;
	letter-spacing: 5px;
	font-size: 2em;
	color: #9d937c;
}

.zh .values h2 {
	font-weight: bold;
	font-family: 'Raleway', 'Avenir', Helvetica, Arial, sans-serif;
}

.values h3 {
	color: #e39200;
	margin-left: 65px;
	font-size: 1.4em;
}

.values p {
	margin-left: 65px;
}

.values .flex {
	display: flex;
	flex-direction: row;
	border-left: 7px solid #d6c3b4;
	padding: 20px;
	margin: 20px 0;
}

.values .flex img {
	float: left;
}

.values img.innovation {
	width: 45px;
}

.values img.excellence {
	width: 80px;
	margin-left: -20px;
	margin-top: 12px;
}

.values img.empathy {
	width: 50px;
}

.values img.integrity {
	width: 45px;
}

.values .left,
.values .right {
	width: 50%;
	padding: 0 20px;
}

.values .home-line {
	width: 507px;
	height: 135px;
	position: absolute;
	bottom: -75px;
	right: 10%;
}

.values .home-line img {
	width: 100%;
}

.home .contact {
	display: flex;
	flex-direction: row;
	justify-content: center;
	padding: 50px 0 150px 0;
}

.home .contact img {
	width: 10%;
	margin:0 1%;
}

.home .contact .container {
	text-align: center;
}


@media handheld,only screen and (max-width: 800px) {
	.home-intro {
		margin: 30px 0 30px 0;
	}

	.home-intro h1 {
		font-size: 2em;
		width: 80%;
		margin-left: auto;
		margin-right: auto;
	}

	.home-intro p {
		width: 80%;
		margin-top:0;
		text-align: center;
		font-size: 1em;
	}

	.values {
		margin-top: 30%;
		margin-bottom: 0;
	}

	.values .top-img {
		width: 80%;
		margin: auto;
	}

	.values .top-img img {
		margin-top: -25%;
	}

	.values h2 {
		text-align: center;
		font-size: 1.7em;
		padding: 20px 0;
	}

	.values .flex {
		display: block;
		border: none;
		padding: 0;
		margin: 0 auto;
		width: 85%;
	}

	.values .left, .values .right {
		width: 100%;
		padding: 0;
	}

	.values .flex img {
		display: block;
		float: none;
		margin: 20px auto 10px auto;
	}

	.values h3 {
		display: block;
		margin: 0;
		text-align: center;
		padding: 10px 0;
		font-size: 1.3em;
	}

	.values p {
		margin: 0;
		padding-bottom: 20px;
		font-size: 1em;	
	}

	.values .home-line {
		display: none;
	}

	.home .contact img {
		width: 80%;
	}

	.home .contact {
		padding: 40px 0 0 0;
		display: block;
	}

	.contact .contact-button {
		text-align: center;
	}

	.contact .contact-button a {
		padding: 10px 30px;
		text-transform: uppercase;
		font-size: 1.7em;
		background: #e39200;
		border-radius: 50px;
		margin: 50px auto;
		text-decoration: none;
		display: inline-block;
		font-family: "Times New Roman", Times, serif;
		color: #fff;
		font-weight: bold;
	}

	.zh .contact .contact-button a {
		font-family: 'Raleway', 'Avenir', Helvetica, Arial, sans-serif;
	}

	.agile__actions {
		position: absolute;
		top: 40%;
		left: 0;
		width: auto !important;
	}

	.agile__dots {
		margin: 0;
		flex-direction: column;
	}

	.agile__dot button {
		margin: 10px;
		width: 12px;
		height: 12px;
	}

	.agile__dot.agile__dot--current button {
		border: 3px solid #FFF;
		width: 15px;
		height: 15px;
		margin: 7px;	
	}

	.VueCarousel-pagination {
		position: absolute;
		top: 25%;
		left: 0;
		width: auto !important;
	}

	.VueCarousel-dot--active,
	.VueCarousel-dot{
		display: block !important;
		margin-top: 0px !important;
	}

	.VueCarousel-dot--active {
		margin-bottom: 5px !important;
		margin-top: 8px !important;
		margin-left: 7px !important;
		border: 3px solid #FFF !important;
	}	
}

</style>